import { createRoot } from "react-dom/client";
import { ConfigProvider } from "antd";
import App from "./App.tsx";
import "antd/dist/reset.css";
import "./index.css";
import { Toaster } from "react-hot-toast";
import { Provider } from "react-redux";
import { store } from "./store";


const getCssVar = (varName: string, fallback: string) => {
  if (typeof document !== "undefined") {
    const value = getComputedStyle(document.documentElement).getPropertyValue(varName).trim();
    return value || fallback;
  }
  return fallback;
};
const corporateTrustTheme = {
  token: {
    colorPrimary: getCssVar("--color-primary-600", "#7C3AED"),
    colorLink: getCssVar("--color-primary-600", "#7C3AED"),
    colorLinkHover: getCssVar("--color-primary-700", "#6D28D9"),
    colorSuccess: getCssVar("--color-success", "#10B981"),
    colorWarning: getCssVar("--color-warning", "#F59E0B"),
    colorError: getCssVar("--color-error", "#EF4444"),
    colorInfo: getCssVar("--color-info", "#2563EB"),
    colorBgBase: getCssVar("--color-bg-base", "#FFFFFF"),
    colorBgLayout: getCssVar("--color-bg-layout", "#F6F6FB"),
    colorTextBase: getCssVar("--color-text-primary", "#1A1730"),
    colorBorder: getCssVar("--color-border-primary", "#ECEAF4"),
    colorBorderSecondary: getCssVar("--color-border-secondary", "#F0EEF6"),
    borderRadius: 8,
    borderRadiusLG: 12,
    fontFamily:
      '"Plus Jakarta Sans", "Inter", "Segoe UI", "Helvetica Neue", Arial, sans-serif',
    fontSize: 14,
    controlHeight: 40,
    boxShadow:
      "0 1px 2px rgba(26, 23, 48, 0.04), 0 10px 30px -18px rgba(26, 23, 48, 0.16)",
    boxShadowSecondary:
      "0 16px 32px -16px rgba(26, 23, 48, 0.22)",
  },
  components: {
    Button: {
      borderRadius: 11,
      controlHeight: 42,
      controlHeightLG: 50,
      controlHeightSM: 34,
      fontWeight: 700,
    },
    Input: {
      borderRadius: 11,
      controlHeight: 44,
      activeBorderColor: getCssVar("--color-primary-600", "#7C3AED"),
      hoverBorderColor: getCssVar("--color-primary-400", "#A78BFA"),
      activeShadow: "0 0 0 3px rgba(109, 40, 217, 0.14)",
    },
    Select: {
      borderRadius: 11,
      controlHeight: 44,
    },
    DatePicker: {
      borderRadius: 11,
      controlHeight: 44,
    },
    Table: {
      borderRadius: 12,
      headerBg: getCssVar("--color-bg-muted", "#F4F3F9"),
      headerColor: getCssVar("--color-text-tertiary", "#9CA3AF"),
    },
    Modal: {
      borderRadiusLG: 16,
    },
    Card: {
      borderRadiusLG: 12,
    },
  },
};

createRoot(document.getElementById("root")!).render(
  <>
    <ConfigProvider theme={corporateTrustTheme}>
      <Provider store={store}>
        <App />
      </Provider>
    </ConfigProvider>
    <Toaster
      position="bottom-right"
      toastOptions={{
        duration: 3000,
        style: {
          fontFamily: '"Plus Jakarta Sans", sans-serif',
          borderRadius: "12px",
          boxShadow: "0 8px 22px -6px rgba(109, 40, 217, 0.5)",
        },
      }}
    />
  </>
);
